import { React, useEffect, useState, useContext } from "react";
import { MyContextProvider } from "../../../../App"
import axios from "axios";
import { API_URL } from "../../../../Constant";
import { GlobalLoading, showLoading } from "react-global-loading";
import { handleUserLevelAccessPermissions, validateRolesIIPHQ } from "../../../../Custom/Custom";
import { ToastContainer, toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { generateRCPI } from "../ExportPriceWagesExcel";
import priceTitle from '../../../../price.json';
import { changeDateFormat, isEndDateGreater } from "../../../../Custom/Custom";

const RCPI = () => {
  const [years, setYears] = useState([]);
  const [yearName, setYearName] = useState("");
  const [rcpiData, setRCPIData] = useState([]);
  const [IIPAnnualAgricultureReportbaseYear, setIIPAnnualAgricultureReportbaseYear] = useState(null);
  const [buttonAccess, setButtonAccess] = useState({
    userLevel: "",
    roles: "",
    isVisible: false,
  });
  const [yearNameNextTitle, setYearNameNextTitle] = useState([]);
  const token = useContext(MyContextProvider).token;
  const decode_token = jwtDecode(token);
  const navigate = useNavigate();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };


  const storedLanguage = localStorage.getItem('language');

  //get next Years 
  const getNextYear = (year) => {
    const nextYear = parseInt(year) + 1;
    return `${year}-${nextYear}`;
  };



  //get Years 
  const getAllYears = () => {
    const currentYear = new Date().getFullYear();
    const yearsArray = [];
    for (let year = currentYear; year >= 2000; year--) {
      yearsArray.push(year);
    }
    return yearsArray;
  };


  useEffect(() => {
    const level = handleUserLevelAccessPermissions(decode_token);
    setButtonAccess(level);
    const getYearList = () => {
      setYears(getAllYears());
    };

    const userRole = async () => {
      showLoading(true);
      try {
        const role = await validateRolesIIPHQ(decode_token);
        if (role) {
          getYearList();
        } else {
          alert(
            "You are not an authorized for IIP Report."
          );
          navigate("/dashboard");
        }
      } catch (error) {
        console.log(error);
        showLoading(false);
      } finally {
        showLoading(false);
      }
    };

    userRole();
  }, []);



  const handleDropdownChange = (e) => {
    switch (e.target.name) {
      case 'year_name':
        setYearName(e.target.value);
        break;
      default:
        console.log("switch case did not match");
        break;
    }
  };

 
  const handleGenerateExcel = async () => {
  if (!yearName) {
    toast.error("Please select a year.");
    return;
  }

  showLoading(true);

  try {
    const postData = { surveyYear: yearName };
    const response = await axios.post(`${API_URL}api/price/rcpi`, postData, config);
    const allData = response.data.data;
    const RCPI = allData.GroupCodes;

    if (RCPI && RCPI.length > 0) {
      let majorGroupIndex = 1;
      let subGroupIndex = 'A';
      let itemIndex = 1;

      const mappedData = [];

      RCPI.forEach(group => {
        mappedData.push({
          majorGroupNameHindi: group.majorGroupNameHindi,
          abc: '',
          def: '',
          efg: '',
          ghi: '',
          majorGroupName: group.majorGroupName,
          type: "group",
          index: majorGroupIndex
        });
        majorGroupIndex++;

        group.subGroups.forEach(subGroup => {
          mappedData.push({
            subGroupNameHindi: subGroup.subGroupNameHindi,
            abc: '',
            def: '',
            efg: '',
            ghi: '',
            subGroupName: subGroup.subGroupName,
            type: "subgroup",
            index: `(${subGroupIndex})`
          });
          subGroupIndex = String.fromCharCode(subGroupIndex.charCodeAt(0) + 1);

          subGroup.itemCodes.forEach(item => {
            mappedData.push({
              itemNameHindi: item.itemNameHindi,
              finalWtNew: item.finalWtNew,
              basePrice: item.basePrice,
              currentPrice: item.currentPrice,
              itemName: item.itemName,
              type: "item",
              index: itemIndex
            });
            itemIndex++;
          });
        });
      });

      setRCPIData(mappedData);
      setIIPAnnualAgricultureReportbaseYear(yearName);

      const excelFileName = `RCPI_${yearName}`;
      const excelObjectData = {
        fileName: excelFileName,
        reportType: excelFileName,
        fileType: 'xls',
        sheetName: 'rcpi',
        firstRowMergeCells: "A1:G1",
        firstRowExportDate: changeDateFormat(new Date()),
        firstRowCellNumber: 12,
        secondRowMergeCells: "A2:G2",
        secondRowText: `कृषकों के घरेलू उपभोक्ता भाव सूचकांक ${yearName}-${parseInt(yearName)+1} `,
        thirdRowMergeCells: "A3:L3",
        thirdRowText: "AGRICULTURE SECTOR",
        baseYear: yearName,
        excelRowData: mappedData.map((item) => {
          let rowStyle = {}; // Default style

          if (item.type === "group") {
            rowStyle = { backgroundColor: "#f0f8ff", fontWeight: "bold" }; // Light blue background and bold text for major groups
          } else if (item.type === "subgroup") {
            rowStyle = { backgroundColor: "#e6e6fa", fontWeight: "bold" }; // Light lavender background and bold text for subgroups
          }

          if (item.type === "group") {
            return [
              item.type,
              item.index,  // Custom indexing for majorGroupName
              item.majorGroupNameHindi,
              item.abc || '0.00',
              item.def || '',
              item.efg || '',
              item.ghi || '',
              item.majorGroupName,
             
            ];
          }
          if (item.type === "subgroup") {
            return [
              item.type,  
              item.index,  // Custom indexing for subGroupName
              item.subGroupNameHindi,
              item.abc || '0.00',
              item.def || '',
              item.efg || '',
              item.ghi || '',
              item.subGroupName,
       
            ];
          }
          if (item.type === "item") {
            return [
              item.type,  // Include type for styling
              item.index,  // Custom indexing for itemName
              item.itemNameHindi,
              item.finalWtNew,
              item.basePrice,
              item.currentPrice,
              item.currentPrice,
              item.itemName,
             
            ];
          }
          return [];
        }).filter(row => row.length > 0),
      };

      generateRCPI(excelObjectData);
      
    } else {
      toast.error("No data available for the selected year.");
    }
  } catch (error) {
    console.error('Error fetching data:', error);
    toast.error("Error fetching data.");
  } finally {
    showLoading(false);
  }
};


  return (
    <>
      <GlobalLoading />
      <ToastContainer />
      <div className="container-fluid py-3">
        <div className="card mx-3 mb-3">
          <div className="card-body pb-1">
            <div className="row align-items-center">
              <h4 className="page_heading">
                <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.RCPI : priceTitle.en.RCPI }} />
              </h4>
              <div className="row align-items-center">
                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                  <label> Select Year </label>
                  <select
                    name="year_name"
                    className="form-select"
                    onChange={handleDropdownChange}
                    value={yearName}
                  >
                    <option value="" disabled>
                      Select Year
                    </option>
                    {years &&
                      years.map((ele, index) => (
                        <option key={index} value={ele}>
                          {getNextYear(ele)}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="col-xl-2 col-lg-12 mb-3">
                  <label className="w-100 d-none d-sm-block">&nbsp;</label>
                  <button onClick={handleGenerateExcel} className="btn btn_orange">Search</button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </>
  )
}
export default RCPI